import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '@supoui/core/services/http.service';
import { CaseDocumentAdapter } from '@supoui/case/components/case-summary/models/case-document';
import { SERVER_API_URL } from '../../app.constants';
import { AttachDocument } from '@supoui/shared/model/attach-document';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private httpService: HttpService, private caseDocumentAdapter: CaseDocumentAdapter) {}

  public getDocument(documentId: string): Observable<Blob> {
    return this.getDocumentUsingPath(documentId, 'services/documentservice/api/documents/data/');
  }

  public getDocumentAsPdf(documentId: string): Observable<Blob> {
    return this.getDocumentUsingPath(documentId, 'services/documentservice/api/documents/data/', 'application/pdf');
  }

  public getDocumentUrl(documentId: string): string {
    return `${SERVER_API_URL}/services/documentservice/api/documents/data/${documentId}`;
  }

  public getTransformWordToPdf(documentId: string): Observable<Blob> {
    return this.httpService.getDocument(`services/casemanagement/api/documents/getPdf/`, documentId);
  }

  public removePasswordFromPDF(documentId: string, password: string, caseId: number): Observable<string> {
    return this.httpService.get<string>(`services/casemanagement/api/documents/removePasswordFromPDF/${documentId}/password/${caseId}`);
  }

  private getDocumentUsingPath(documentId: string, path: string, overrideMimeType?: string): Observable<Blob> {
    return this.httpService.getDocument(path, documentId, overrideMimeType);
  }

  public addDocumentToCase(document: AttachDocument): Observable<AttachDocument> {
    return this.httpService.post<AttachDocument>('services/casemanagement/api/documents/case/attachDocument', document);
  }
}
